import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule} from '@angular/material/button'
import { NbActionsModule, NbButtonModule, NbContextMenuModule, NbIconModule, NbLayoutModule, NbMenuModule, NbSidebarModule, NbUserModule } from '@nebular/theme';
import { DashboardComponent } from './dashboard.component';
import { MenuComponent } from './menu/menu.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { SelectModule } from 'src/app/filtros/components/select/select.module';
import { NbSecurityModule } from '@nebular/security';
import { DialogConfirmComponent } from '../auth/dialog/dialog-confirm/dialog-confirm.component';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [
    DashboardComponent,
    MenuComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    NbLayoutModule,
    NbSidebarModule,
    NbButtonModule,
    NbMenuModule,
    DashboardRoutingModule,
    SelectModule,
    NbUserModule,
    NbActionsModule,
    NbContextMenuModule,
    NbSecurityModule,
    NbIconModule,
    MatDialogModule
  ],
  exports:[DashboardComponent]
})
export class DashboardModule { }
